"use client";
import clsx from "clsx";
import React, { useId, useState } from "react";
import { cn } from "../../lib/utils/cn";

type PSideNote = {
  children: React.ReactNode;
  id: string;
  inlineExpand: boolean;
  pad: number;
};

// Global. Reset for each page
function SideNote({ children, id, inlineExpand, pad }: PSideNote) {
  if (inlineExpand) {
    return (
      <span
        id={id}
        className="blog-sidenote text-gray-500 text-base italic leading-snug"
      >
        {children}
      </span>
    );
  }

  return (
    <span
      className={cn(
        "absolute right-0 mr-0 leading-tight -mt-1 p-2 bg-sc-bg border border-transparent duration-150 group-hover:bg-try-color hidden xl:inline-block xl:float-right w-64 group-hover:!z-50 rounded",
        false && "group-hover:shadow-sm group-hover:border-gray-200 dark:group-hover:border-slate-700 group-hover:border",
      )}
      style={{ marginTop: pad }}
    >
      <span
        id={id}
        className={cn(
          "tracking-wide leading-4",
          `text-gray-500 relative dark:text-slate-400 group-hover:text-gray-800 dark:group-hover:text-slate-300 text-xs z-10`,
          `blog-sidenote before:duration-150 group-hover:before:content-[counter(blog-sidenote)_"."] before:border before:border-transparent before:text-slate-300  group-hover:before:text-gray-400 dark:before:text-gray-500 group-hover:dark:before:text-gray-200 before:pl-1 before:pr-0.5 before:absolute before:z-0 before:w-[2em] before:-left-[39px] before:rounded-l before:py-0.5`,
          false && "group-hover:before:border-gray-200 group-hover:dark:before:border-slate-700 group-hover:before:shadow-sm ",
            `after:content-[counter(blog-sidenote)_"."]  after:duration-150 after:text-transparent after:w-1 after:absolute after:top-[1px] after:-left-[12px] after:z-10 after:py-0.5`,
        )}
      >
        <span>{children}</span>
      </span>
    </span>
  );
}

type PNote = {
  children: React.ReactNode;
  id: string | null;
  pad: number;
};
export function Note({ children, id = null, pad }: PNote) {
  const [show, setShow] = useState(false);
  const toggleRef = () => {
    setShow((s) => !s);
  };
  const innerId = useId();
  const ref = `ref-${id || innerId}`;
  return (
    <span className="group inline select-none">
      <span
        className="inline p-1 w-1 bg-red xl:hidden blog-sidenote-ref text-nord-3 cursor-pointer underline"
        onClick={toggleRef}
      />
      <label
        className="hidden group-hover:text-green-500 dark:group-hover:text-slate-300 xl:inline blog-sidenote-ref text-nord-4/90 text-sm p-0.5"
        htmlFor={ref}
      />
      <SideNote id={ref} inlineExpand={show} pad={pad}>
        {children}
      </SideNote>
    </span>
  );
}
